@if (isOpen()) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
    (click)="onBackdropClick($event)"
  >
    <div
      class="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl"
      role="alertdialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="messageId"
      (click)="$event.stopPropagation()"
    >
      <h2 [id]="titleId" class="text-lg font-semibold text-slate-900">{{ title() }}</h2>
      <p [id]="messageId" class="mt-3 text-sm leading-6 text-slate-700">{{ message() }}</p>

      <div class="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <button type="button" class="button-secondary" (click)="onCancel()" autofocus>
          {{ cancelButton() }}
        </button>
        <button type="button" class="button-primary" (click)="onConfirm()">
          {{ okButton() }}
        </button>
      </div>
    </div>
  </div>
}
